import React from 'react';
import { useDelay } from 'hooks/useDelay';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';

interface IProps {
	onConsentEvent: () => void;
	description: string;
	additionalDescription?: string;
	visibleTime?: number;
}

export const ModalSentSuccessfullyNew: React.FC<IProps> = ({
	onConsentEvent,
	description,
	additionalDescription,
	visibleTime,
}) => {
	useDelay(onConsentEvent, visibleTime);
	const showOkButton = !visibleTime;

	return (
		<div className="absolute inset-0 flex items-center justify-center" data-test="ModalSentSuccessfullyIsVisible">
			<div className="w-full max-w-120 p-8 rounded flex flex-col items-center gap-6 bg-white-00-new shadow-500">
				<Icon name={IconName.success} size="hero" className="text-green-03-new" />
				<div className="w-full flex flex-col items-center gap-4">
					<Text
						translationNameSpace="modals"
						translationKey={description}
						size="xl"
						weight="bold"
						align="center"
					/>
					{additionalDescription && (
						<Text
							translationNameSpace="modals"
							translationKey={additionalDescription}
							size="m"
							align="center"
						/>
					)}
				</div>
				{showOkButton && (
					<NewButton
						variant="primary"
						color="purple"
						size="small"
						type="submit"
						testId="okButton"
						onClick={onConsentEvent}>
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</NewButton>
				)}
			</div>
		</div>
	);
};
